import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import './MainLayout.css';

const MainLayout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="admin-layout">
      {/* Mobile Backdrop */}
      {sidebarOpen && (
        <div 
          className="sidebar-backdrop" 
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />

      <div className="main-content-wrapper">
        <Header 
          title={title} 
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} 
        />
        <main className="page-content fade-in">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
